<template>
	<div class="modal-experience">
		<table class="table-experiences mb-3">
			<tr>
				<th>Experience Name</th>
				<th style="width: 100px">Status</th>
				<th style="width: 80px"></th>
				<th style="width: 50px"></th>
			</tr>
			<tr v-for="(item, index) in lists" :key="index">
				<td>{{ item.name }}</td>
				<td>{{ item.status }}</td>
				<td></td>
				<td>
					<a href="#">Edit</a>
				</td>
			</tr>
		</table>

		<div class="mt-1">
			<button class="btn experience" type="button" @click="modalAffiliation = !modalAffiliation">
				<img :src="AddIcon" /> {{ textButton }}
			</button>
		</div>
		<ModalAffiliationsExpreience
			v-if="modalAffiliation == true && type == 'experience'"
			@close="onClose"
			:type="type"
		/>
		<ModalAffiliationsGroup v-if="modalAffiliation == true && type == 'group'" @close="onClose" :type="type" />
		<ModalDistribution v-if="modalAffiliation == true && type == 'distribution'" @close="onClose" :type="type" />
	</div>
</template>

<script>
import ModalAffiliationsExpreience from '@/components/Modals/ModalAffiliationsExperience.vue';
import ModalAffiliationsGroup from '@/components/Modals/ModalAffiliationsGroup.vue';
import ModalDistribution from '@/components/Modals/ModalDistribution.vue';
import AddIcon from '@/assets/images/ew-icon_add.svg';
export default {
	props: {
		value: {
			type: Array,
			default() {
				return [];
			},
		},
		type: {
			type: String,
			default: '',
		},
		textButton: {
			type: String,
			default: '',
		},
		lists: {
			type: Array,
			default: [],
		},
	},
	components: {
		ModalAffiliationsExpreience,
		ModalAffiliationsGroup,
		ModalDistribution,
	},
	data() {
		return {
			modalAffiliation: false,
			AddIcon: AddIcon,
		};
	},
	methods: {
		onClose(value) {
			this.modalAffiliation = false;
			this.$emit('input', value);
		},
	},
};
</script>

<style lang="scss" scoped>
$experience-color: #1da1f2;
.modal-experience {
	.table-experiences {
		width: 100%;
		color: #fff;
		font-size: 12px;

		tr {
			th {
				font-weight: bold;
			}
		}
		a {
			color: #fff;
		}
	}

	.btn {
		&.experience {
			background-color: $experience-color;
		}
	}
}
</style>
